import { RouteRecordRaw } from "vue-router";
import { addRoutes } from "@/core/router";
import { registerNavMenuItem, NavMenuItem } from "@/core/layout";

const configurationsRoute: RouteRecordRaw = {
  path: "/configurations",
  name: "configurations",
  component: () => import("@/configuration/pages/Configurations.vue"),
  meta: {
    authorize: ["CONFIGURATIONS.LIST.VIEW"],
  },
};

const createConfigurationsRoute: RouteRecordRaw = {
  path: "/configurations/create",
  name: "createConfigurations",
  component: () => import("@/configuration/pages/EditConfigurations.vue"),
  meta: {
    authorize: ["CONFIGURATIONS.LIST.CREATE"],
  },
};

const editConfigurationsRoute: RouteRecordRaw = {
  path: "/configurations/edit/:id/:level/:ownerId",
  name: "editConfigurations",
  component: () => import("@/configuration/pages/EditConfigurations.vue"),
  meta: {
    authorize: ["CONFIGURATIONS.LIST.EDIT"],
  },
};
addRoutes([
  configurationsRoute,
  createConfigurationsRoute,
  editConfigurationsRoute,
]);

const configurationItem: NavMenuItem = {
  iconName: "sliders-h",
  label: "Configurations",
  name: "configurations",
  targetRoute: {
    path: "/configurations",
    name: "configurations",
    component: () => import("@/configuration/pages/Configurations.vue"),
  },
  authority: "CONFIGURATIONS.LIST.VIEW",
  rank: 30,
  isParent: false,
  hasParent: false,
};
registerNavMenuItem(configurationItem);
